import { render, staticRenderFns } from "./CenterOnParent.vue?vue&type=template&id=bd74d1be"
import script from "./CenterOnParent.vue?vue&type=script&lang=ts"
export * from "./CenterOnParent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports